<template>
  <section class="p-6 flex flex-col gap-6">
    <nav class="text-gray-600 text-sm">
      <span class="font-semibold cursor-pointer" @click="$router.push('/')">Home</span>
      <span class="mx-2">/</span>
      <span class="text-gray-800 font-bold">Services</span>
    </nav>

    <h3 class="font-bold text-2xl">Services</h3>

    <div class="flex items-center justify-between w-full mb-4">
      <input
        v-model="search"
        placeholder="Search by Arabic or English name..."
        class="border border-gray-300 rounded-md px-4 py-2 w-1/3"
      />
      <button
        @click="$router.push({ name: 'AddService' })"
        class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
      >
        + Add Service
      </button>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full border-collapse bg-white rounded-lg shadow">
        <thead>
          <tr class="bg-gray-100 text-left text-sm font-semibold">
            <th class="px-4 py-2">Arabic Name</th>
            <th class="px-4 py-2">English Name</th>
            <th class="px-4 py-2">Price</th>
            <th class="px-4 py-2">Active</th>
            <th class="px-4 py-2">Icon</th>
            <th class="px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="service in filteredServices"
            :key="service.id"
            class="border-t hover:bg-gray-50 text-sm"
          >
            <td class="px-4 py-2">{{ service.name_ar }}</td>
            <td class="px-4 py-2">{{ service.name_en }}</td>
            <td class="px-4 py-2">{{ service.price_text || "-" }}</td>

            <td class="px-4 py-2">
              <span :class="service.is_active ? 'text-green-600' : 'text-red-500'">
                {{ service.is_active ? "Active" : "Inactive" }}
              </span>
            </td>

            <!-- ✅ ICON -->
      <td class="px-4 py-2">
  <img
    v-if="getServiceIcon(service) && !service.__iconError"
    :src="getServiceIcon(service)"
    class="w-12 h-12 object-cover rounded shadow"
    alt="Service icon"
    @error="service.__iconError = true"
  />

  <div
    v-else
    class="w-12 h-12 bg-gray-200 rounded flex items-center justify-center text-gray-500 text-xs shadow"
  >
    No Icon
  </div>
</td>


            <td class="px-4 py-2 text-center whitespace-nowrap">
              <button
                @click="$router.push({ name: 'EditService', params: { id: service.id } })"
                class="text-green-600 hover:underline mx-1"
              >
                Edit
              </button>

              <button
                @click="deleteService(service.id)"
                class="text-red-600 hover:underline mx-1"
              >
                Delete
              </button>
            </td>
          </tr>

          <tr v-if="filteredServices.length === 0">
            <td colspan="6" class="text-center py-4 text-gray-500">
              No services found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import apiClient from "@/apiClient";

const services = ref([]);
const search = ref("");

const API_BASE_URL = "https://api.transgateacd.com";

function getServiceIcon(service) {
  if (service?.icon_url) return service.icon_url;
  if (service?.icon_path) return `${API_BASE_URL}/storage/${service.icon_path}`;
  return "";
}

async function fetchServices() {
  try {
    const res = await apiClient.get("/admin/services");

    services.value = (res.data?.data?.services || []).map((s) => ({
      ...s,
      __iconError: false,
    }));
  } catch (error) {
    console.error("Error fetching services:", error);
    services.value = [];
  }
}


const filteredServices = computed(() => {
  if (!search.value.trim()) return services.value;
  const q = search.value.toLowerCase();

  return services.value.filter(
    (s) =>
      String(s.name_ar || "").toLowerCase().includes(q) ||
      String(s.name_en || "").toLowerCase().includes(q)
  );
});

async function deleteService(id) {
  if (!confirm("Delete this service?")) return;

  try {
    await apiClient.delete(`/admin/services/${id}`);
    fetchServices();
  } catch (error) {
    alert("Failed to delete service.");
  }
}

onMounted(fetchServices);
</script>
